import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BrokerPortalFeatureCodes } from '@brokerportal/common/enums';
import { FeatureFlagService, PortalConfigurationService } from '@brokerportal/common/services';
import { environment } from 'environments/environment';

@Component({
    selector: 'bp-exchange-auth',
    templateUrl: './exchange-auth.component.html',
    styleUrls: ['./exchange-auth.component.scss']
})
export class ExchangeAuthComponent implements OnInit {
    isLoading: boolean;
    constructor(
        private route: ActivatedRoute,
        private featureFlagService: FeatureFlagService,
        private portalConfigurationService: PortalConfigurationService
    ) {}

    ngOnInit() {
        // The cached portal configuration belongs to whoever was signed in before this login, and it
        // outlives a same-tab re-login. Drop it so the user about to sign in cannot be shown (or
        // announced to Zoho SalesIQ as) the previous user.
        this.portalConfigurationService.clear();

        this.isLoading = true;
        const fusionAuthConfig = environment.fusionAuth;
        const baseApplicationUrl = environment.baseAppUrl;

        const queryParams = this.route.snapshot.queryParams;
        const returnUrl = `${baseApplicationUrl}/${queryParams['returnUrl'] || 'dashboard'}`;

        window.location.replace(
            `${environment.membersUrl}/login/Auth?client_id=${fusionAuthConfig.clientId}&returnUrl=${returnUrl}`
        );
    }
}
